// ./resources/components/videojs/SkipButton.js
import videojs from 'video.js';

// Get the Button component from Video.js
const Button = videojs.getComponent('Button');

// Define the SkipButton class
class SkipButton extends Button {
    constructor(player, options) {
        super(player, options);
        this.controlText('Skip to Next Video');
    }

    // Define the CSS classes for the button
    buildCSSClass() {
        return 'vjs-skip-button vjs-control vjs-button ' + super.buildCSSClass();
    }

    // Define the click behavior
    handleClick() {
        const nextVideoUrl = this.options_.nextVideoUrl;
        if (nextVideoUrl) {
            // Navigate to the next video URL
            window.location.href = nextVideoUrl;
        }
    }
}

// Register the SkipButton component with Video.js
videojs.registerComponent('SkipButton', SkipButton);
